// @ts-nocheck
import onePageCheckoutProductListOverlayReducer, {
    OnePageCheckoutProductListOverlayActions,
} from "@store/Framework/Store/Starter/Components/OnePageCheckoutProductListOverlay/OnePageCheckoutProductListOverlayReducer";
import { combineReducers } from "redux";

const componentsReducer = combineReducers({
    onePageCheckoutProductListOverlay: onePageCheckoutProductListOverlayReducer,
});

export type ComponentsActions = OnePageCheckoutProductListOverlayActions;

export default componentsReducer;
